import React, { LegacyRef, MutableRefObject, useContext, useRef } from 'react';
import { Button, SplitButton } from '@progress/kendo-react-buttons';
import { TicketApi } from '../../../../redux/api/TicketApi';
import { expandedState, processTreeData } from '../../../../utils/TreeDataOperations';
import { TreeView, TreeViewExpandChangeEvent } from '@progress/kendo-react-treeview';
import { Popup, PopupHandle } from '@progress/kendo-react-popup';
import { IQuickNote } from '../../../../types/Ticket/IQuickNotes';
import { ResetAction, SetQuickNote } from '../../../../slices/ActionSlice';
import { useReduxDispatch, useReduxSelector } from '../../../../redux/hooks';
import { setActionExpanded } from '../../../../slices/TicketDetailUISlice';
import { RevUserContext } from '../../../../context/UserContext';
import { IUserProfile } from '../../../../types/User/IUserProfile';
import { isMobile } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';


const AddActionButton: React.FC = () => {
    const navigate = useNavigate();
    const updateState = useReduxDispatch();
    const quickNoteId = 0;
    const selectField = "selected";
    const expandField = "expanded";
    const dataItemKey = "Id";
    const subItemsField = "QuickNotes";
    const fields = { selectField, expandField, dataItemKey, subItemsField };
    const profile = useContext<IUserProfile>(RevUserContext)
    const { data: quickNotes, refetch } = TicketApi.useGetQuickNotesQuery();
    const [show, setShow] = React.useState(false);
    const [expanded, setExpanded] = React.useState(quickNotes?.length > 0 ? [quickNotes?.[0][dataItemKey]] : []);
    const selectedQuickNote = quickNotes?.map(q => q.QuickNotes.find(qn => qn.Id === quickNoteId)).find(qn => qn?.Id === quickNoteId);
    const [value, setValue] = React.useState<IQuickNote>(selectedQuickNote);
    const { actionExpanded } = useReduxSelector(state => state.ticketDetailsUI);
    const { HTML_Notes } = useReduxSelector(state => state.actionDetails.action);
    const treeData = React.useMemo(
        () => {
            return processTreeData(quickNotes || [], { expanded, value }, fields)
        },

        [quickNotes, expanded, value]
    );
    const onExpandChange = React.useCallback(
        (event: TreeViewExpandChangeEvent) =>
            setExpanded(expandedState(event.item, dataItemKey, expanded)),
        [expanded]
    );

    const quickNoteSelected = (event) => {
        console.log('quickNoteSelected', event?.item)

        //Top level category clicked
        if (event?.item && event?.item.QuickNotes) {
            if (!expanded.includes(event?.item.Id))
                setExpanded([event?.item.Id]); //expand
            else
                //let newArray = [...expanded].splice(expanded.indexOf(event?.value.Id)
                setExpanded((oldVal) => {
                    let newVal = [...oldVal]
                    newVal.splice(expanded.indexOf(event?.item.Id), 1)
                    return newVal;
                }); //collaps
            //setShow(true); //stay open

            return
        }


        updateState(setActionExpanded(1))

        setShow(false);

        updateState(SetQuickNote(event.item));
    }

    const parent = useRef(null);
    const popupRef = useRef<PopupHandle>(null);

    //A listener to close the popu if the user clicks outside of it
    React.useEffect(() => {
        const listener = (e) => {
            // console.log('listener', e.target)
            if (!popupRef?.current.element?.contains(e.target)) {
                setShow(false);
            }
        }
        document.addEventListener('mousedown', listener);
        return () => {
            document.removeEventListener('mousedown', listener);
        }
    }, [popupRef]);

    const addAction = () => {

        if (actionExpanded === 1 && HTML_Notes?.length > 0 && !window.confirm('You have unsaved changes. Are you sure you want to cancel this Action note?')) return;

        //need to reset the action state so it doesn't show a previously partially filled action
        updateState(ResetAction(null));

        if (isMobile)
            navigate('action');
        else {
            updateState(setActionExpanded(actionExpanded !== 1 ? 1 : 0))
        }
    }


    return (<div ref={parent}>
        {(profile?.Features?.Quick_Notes && !profile?.Features.External_Interface && !isMobile) ?
            <SplitButton onButtonClick={addAction} title='Add Action' opened={show} imageUrl='./images/button_add_action.png' className="add-action" onOpen={() => setShow((s) => !s)} items={[{ text: '' }]} ></SplitButton>
            : <Button onClick={addAction} title='Add Action' imageUrl='./images/button_add_action.png' className="add-action" ></Button>}

        <Popup ref={popupRef} anchor={parent?.current} popupClass='quick-notes-popup' show={show}>
            <h6 className='ms-2'> Quick notes</h6>
            <TreeView className='' expandIcons={true} data={treeData} textField='Name' childrenField={subItemsField} onExpandChange={onExpandChange} onItemClick={quickNoteSelected}
                key={dataItemKey}
                selectField={selectField}
                expandField={expandField}

            />
        </Popup>
        {/* treeData = {JSON.stringify(treeData)} */}
    </div>
    );
};

export default AddActionButton;